import { connect } from 'react-redux'
import { getFromSettings } from 'src/utils/helpers'
import {
  getInventoryGroup,
  inventoryItemDelete,
  inventorySetItemAddedDisclaimerFalse,
} from '../actions'
import Group from './Group'

const mapStateToProps = state => {
  return {
    isGetGroupInProgress: state.inventory.isGetGroupInProgress,
    isDeleteItemInProgress: state.inventory.isDeleteItemInProgress,
    getGroupResponse: state.inventory.getGroupResponse,
    group: state.inventory.group,
    items: state.inventory.items,
    deleteItemResponse: state.inventory.deleteItemResponse,
    showItemAddedDisclaimer: state.inventory.showItemAddedDisclaimer,
    labels: getFromSettings(state, 'labels', {}),
  }
}

const mapDispatchToProps = {
  getInventoryGroup,
  inventoryItemDelete,
  inventorySetItemAddedDisclaimerFalse,
}

export default connect(mapStateToProps, mapDispatchToProps)(Group)
